import useGauge from '@containers/shipInfoPage/useGauge'
import { Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

import Dashboard from '../Dashboard/Dashboard'

type OvalGaugeClusterProps = {
  side: 'left' | 'right'
}

export default function OvalGaugeCluster ({ side }: OvalGaugeClusterProps) {
  const [gauges, options, showMekka] = useGauge(side)
  const { depth, heading, pressure, speed, time, wind, temperature, mekkah, location } = options
  const { t } = useTranslation()

  if (!gauges?.length) {
    return <Typography variant="h3" align="center">
      {t('No gauges configured')}
    </Typography>
  }

  return <Dashboard
    showDepth={{ active: depth.active, order: depth.order }}
    showOrientation={{ active: heading.active, order: heading.order }}
    showPressure={{ active: pressure.active, order: pressure.order }}
    showSpeed={{ active: speed.active, order: speed.order }}
    showTime={{ active: time.active, order: time.order }}
    showWind={{ active: wind.active, order: wind.order }}
    showWeather={{ active: temperature.active, order: temperature.order }}
    showMecca={{ active: showMekka && mekkah.active, order: mekkah.order }}
    showEarth={{ active: location.active, order: location.order }}
    ovalLeft={side === 'left'}
    ovalRight={side === 'right'}
  />
}
